/*
  FAQ split -- accordion
  Rows are native <details>, so they open/close with no JS at all.
  This animates the panel height with ONE shared duration for open AND close,
  plus the optional "one open at a time" behaviour.

  COREEX Focal port: carried over from dev-coreex-theme unchanged. This file has
  no Dawn dependency -- it keys off the .faq-split class names and the data-*
  attributes on the section root, all of which the Focal markup keeps.
*/
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setupSection(section) {
    if (!section || section.__fqInit) return;
    section.__fqInit = true;

    var single = section.getAttribute('data-single-open') === 'true';
    var ms = (parseFloat(section.getAttribute('data-panel-speed')) || 0.3) * 1000;
    var items = section.querySelectorAll('.faq-split__item');

    function closeItem(item, animate) {
      var panel = item.querySelector('.faq-split__panel');
      if (!panel || !item.open) return;

      if (!animate || reduced.matches) {
        item.open = false;
        return;
      }

      item.classList.add('is-closing');
      var from = panel.offsetHeight;
      var anim = panel.animate([{ height: from + 'px' }, { height: '0px' }], {
        duration: ms,
        easing: 'ease',
      });
      item.__anim = anim;
      anim.onfinish = function () {
        item.open = false;
        item.classList.remove('is-closing');
        panel.style.height = '';
        item.__anim = null;
      };
    }

    function openItem(item) {
      var panel = item.querySelector('.faq-split__panel');
      var inner = item.querySelector('.faq-split__panel-inner');
      if (!panel || !inner) {
        item.open = true;
        return;
      }

      item.open = true;
      if (reduced.matches) return;

      var to = inner.offsetHeight;
      var anim = panel.animate([{ height: '0px' }, { height: to + 'px' }], {
        duration: ms,
        easing: 'ease',
      });
      item.__anim = anim;
      anim.onfinish = function () {
        panel.style.height = '';
        item.__anim = null;
      };
    }

    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var summary = item.querySelector('.faq-split__summary');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          // take over from the browser so open AND close can both animate
          e.preventDefault();

          if (item.__anim) item.__anim.cancel();

          if (item.open) {
            closeItem(item, true);
            return;
          }

          if (single) {
            for (var j = 0; j < items.length; j++) {
              if (items[j] !== item) {
                if (items[j].__anim) items[j].__anim.cancel();
                closeItem(items[j], true);
              }
            }
          }

          openItem(item);
        });
      })(items[i]);
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.faq-split');
    for (var i = 0; i < nodes.length; i++) setupSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.faq-split');
    if (r) {
      r.__fqInit = false;
      setupSection(r);
    }
  });
})();
